import { render, staticRenderFns } from "./EmployeeSalaryInformation.vue?vue&type=template&id=4b99c372"
import script from "./EmployeeSalaryInformation.vue?vue&type=script&lang=js"
export * from "./EmployeeSalaryInformation.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSalaryInformation.vue?vue&type=style&index=0&id=4b99c372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports